// Screen `document-variant` (owner: doc-variants, owner feedback F12): a record's own version of a PDF template.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { VariantEditor } from '../../../../../features/doc-variants/VariantEditor';

const Search = z.object({
  tab: z.enum(['clauses', 'redline', 'history', 'update']).catch('clauses').default('clauses'),
  clause: z
    .string()
    .max(80)
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/_app/documents/variant/$templateId/$recordId')({
  validateSearch: Search,
  component: VariantRoute,
});

function VariantRoute() {
  const { templateId, recordId } = Route.useParams();
  const { tab, clause } = Route.useSearch();
  return (
    <VariantEditor
      key={`${templateId}:${recordId}`}
      templateId={templateId}
      recordId={recordId}
      tab={tab}
      {...(clause ? { clause } : {})}
    />
  );
}
